<template>
  <div class="logo-cards__item">
    <div class="logo-cards__img">
      <img
        v-if="logo"
        v-lazy-load
        :data-src="logo"
        alt=""
      >
    </div>
    <div class="logo-cards__text">
      <h3
        v-if="title"
        class="logo-cards__title"
        v-html="title"
      ></h3>
      <div
        class="logo-cards__description"
        v-html="description"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoCardsItem',
  props: {
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .logo-cards__item {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 220px auto;
    max-width: 1172px;
    background-color: #FFF;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 0 2px rgba(0, 0, 0, 0.12);

    @media (max-width: $breakpoint-md) {
      grid-auto-flow: row;
      grid-template-columns: 1fr;
    }
  }

  .logo-cards__img {
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid transparentize($primary, 0.9);
    padding: 28px;

    @media (max-width: $breakpoint-md) {
      justify-content: flex-start;
      border-right: none;
      border-bottom: 1px solid transparentize($primary, 0.9);
      padding: 28px 24px;
    }

    img {
      max-width: 100%;

      @media (max-width: $breakpoint-md) {
        max-height: 70px;
      }
    }
  }

  .logo-cards__text {
    padding: 64px 24px;

    p:last-child {
      margin-bottom: 0;
    }
  }

  .logo-cards__title {
    margin-bottom: 16px;
  }
</style>